document.addEventListener('change', (e) => {
  const cb = e.target.closest?.('[data-po-checkbox]');
  if (!cb) return;

  const root = cb.closest('[data-cart-po]');
  if (!root) return;

  const area = root.querySelector('[data-po-area]');
  const po = root.querySelector('[data-po-number]');
  if (!area) return;

  if (cb.checked) {
    area.style.display = 'block';
  } else {
    area.style.display = 'none';
    if (po) po.value = '';
  }
});
